import BaseModelAPI from '../BaseModelAPI';

export default class NextProcessList extends BaseModelAPI {

	static entity = 'nextprocesslist'
	static entityName = 'nextprocess';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
